import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import './SetupGuide.css';
import { Building2, Truck, Users, UserSquare2, Landmark } from 'lucide-react';

const SetupGuide = ({ userEmail }) => {
  const navigate = useNavigate();
  const [setupSteps, setSetupSteps] = useState([
    {
      id: 'machines',
      title: 'Makinelerini Tanıt',
      description: 'Şirketinize ait iş makinelerini sisteme ekleyin.',
      path: '/makine-tanimlama',
      completed: false,
      icon: Truck
    },
    {
      id: 'operators',
      title: 'Operatör Bilgilerini Gir',
      description: 'Makine operatörlerinizi sisteme tanıtın.',
      path: '/operator-ekle',
      completed: false,
      icon: UserSquare2
    },
    {
      id: 'customers',
      title: 'Cari Tanıtımlarını Yap',
      description: 'Müşterilerinizi ve şantiyelerinizi ekleyin.',
      path: '/musteri-listesi',
      completed: false,
      icon: Users
    },
    {
      id: 'banks',
      title: 'Banka Tanıtımı Yap',
      description: 'Banka hesaplarınızı sisteme ekleyin.',
      path: '/banka-tanitim',
      completed: false,
      optional: true,
      icon: Landmark
    }
  ]);

  useEffect(() => {
    const initializeSetupProgress = async () => {
      if (!userEmail) return;

      const db = getFirestore();
      const userDocRef = doc(db, 'users', userEmail);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        if (!userDoc.data().setupProgress) {
          await updateDoc(userDocRef, {
            setupProgress: {
              machines: false,
              operators: false,
              customers: false,
              banks: false
            }
          });
        }

        const setupProgress = userDoc.data().setupProgress || {};
        
        setSetupSteps(prevSteps => 
          prevSteps.map(step => ({
            ...step,
            completed: setupProgress[step.id] || false
          }))
        );
      }
    };

    initializeSetupProgress();
  }, [userEmail]);

  const handleStepClick = async (step) => {
    // Dashboard'daki section'ları tetiklemek için
    if (step.id === 'machines') {
      navigate('/dashboard');
      window.dispatchEvent(new CustomEvent('setActiveSection', { detail: 'makineTanitma' }));
    } else if (step.id === 'operators') {
      navigate('/dashboard');
      window.dispatchEvent(new CustomEvent('setActiveSection', { detail: 'operatorEkle' }));
    } else if (step.id === 'customers') {
      navigate('/dashboard');
      window.dispatchEvent(new CustomEvent('setActiveSection', { detail: 'musteriListesi' }));
    } else if (step.id === 'banks') {
      navigate('/dashboard');
      window.dispatchEvent(new CustomEvent('setActiveSection', { detail: 'bankaTanitimKarti' }));
    }
  };

  // Zorunlu adımların tamamlanıp tamamlanmadığını kontrol et
  const mandatoryStepsCompleted = setupSteps
    .filter(step => !step.optional)
    .every(step => step.completed);

  if (mandatoryStepsCompleted) {
    return null;
  }

  return (
    <div className="setup-guide">
      <div className="setup-guide-header">
        <div className="setup-guide-title">
          <h2>Sistemi Kurun</h2>
          <p>Hops sistemini kullanmaya başlamak için gerekli bilgileri girin</p>
        </div>
      </div>

      <div className="setup-sections">
        <div className="setup-section">
          <h3>SİSTEM KURULUMU İÇİN GEREKLİ BİLGİLER</h3>
          <div className="setup-steps">
            {setupSteps.map((step) => {
              const Icon = step.icon;
              return (
                <div
                  key={step.id}
                  className={`setup-step ${step.completed ? 'completed' : ''} ${step.optional ? 'optional' : ''}`}
                  onClick={() => handleStepClick(step)}
                >
                  <div className="step-icon">
                    <Icon size={24} />
                  </div>
                  <div className="step-content">
                    <div className="step-header">
                      <h4>{step.title}</h4>
                      {step.completed && <span className="completion-check">✓</span>}
                    </div>
                    <p>{step.description}</p>
                    {step.optional && !step.completed && (
                      <span className="optional-badge">Opsiyonel</span>
                    )}
                  </div>
                  <div className="step-arrow">›</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupGuide; 